import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import { Checkbox } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { Radio } from "../../../../../_metronic/_partials/controls/forms/Radio";
import DeleteIcon from "../../../../../assets/img/company/Vector.svg";
import resetLight from "../../../../../assets/img/resetLightIcon.svg";
import resetDark from "../../../../../assets/img/resetDarkIcon.svg";

import * as Yup from "yup";
import IconClose from "../../../../../assets/img/icon-close.svg";
// import IconReset from "../../../../../assets/img/reset.png";
// import ConfirmationDialoge from "../../../confirmationDialoge";
import * as rolesActions from "../../../../../_redux/roles/rolesActions";
import * as usersActions from "../../../../../_redux/users/usersActions";
import { Input, SwitchToggler, Card } from "../../../../../_metronic/_partials/controls";
import {
  POS_OPTIONS,
  BACK_OFFICE_OPTIONS,
  POS_OPTIONS_DEFAULT,
  BACK_OFFICE_OPTIONS_DEFAULT,
  POS_OPTIONS_MANAGER,
  BACK_OFFICE_OPTIONS_MANAGER,
  POS_OPTIONS_CASHIER,
  BACK_OFFICE_OPTIONS_CASHIER,
  BACK_OFFICE_OPTIONS_NEW_ROLE,
} from "./rolesConstants";
import cloneDeep from "lodash/cloneDeep";
import SubscriptionDialog from "../SubscriptionDialog";
import { i18n } from "../../../private/languageSelector";
import { handleDataPermissions, translateRoleName } from "../../../../../helpers/helpers";
import { isEqual } from "lodash";

// Validation schema
export const AddRoleSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, i18n("Company.Minimun3Alphabets"))
    .max(20, i18n("Company.Max20Alphabets"))
    .required(i18n("Company.RoleNameRequired")),
});

const initAddState = {
  name: "",
  pos: false,
  backOffice: false,
};

export function RolesEditForm({ edit, disabled, roleForEdit, nameDisabled, openRolesAddDialog, setOpenRolesAddDialog, setShowDeleteRoleModal }) {
  const dispatch = useDispatch();

  const [usersWithRole, setUsersWithRole] = useState([]);
  const [roleForEditing, setRoleForEditing] = useState({});
  const [showPosOptions, setShowPosOptions] = useState(false);
  const [usersIdsWithRole, setUsersIdsWithRole] = useState([]);
  const [posOptions, setPosOptions] = useState([...POS_OPTIONS]);
  // const [showConfirmChanges, setShowConfirmChanges] = useState(false);
  // const [showDefaultChanges, setShowDefaultChanges] = useState(false);
  const [resetToDefault, setResetToDefault] = useState(false);
  const [showBackOfficeOptions, setShowBackOfficeOptions] = useState(false);
  const [backOfficeOptions, setBackOfficeOptions] = useState([...BACK_OFFICE_OPTIONS]);
  const [showUnsavedChangesModal, setShowUnsavedChangesModal] = useState(false);
  const [isFormFilled, setIsFormFilled] = useState(false);

  const { users, user } = useSelector((state) => ({
    users: state.users.entities,
    user: state.auth?.user,
  }));

  useEffect(() => {
    if (roleForEdit && edit) {
      dispatch(usersActions.fetchUsers());

      let backOfficeData = cloneDeep(Object.values(roleForEdit.backOfficePayload));
      let posData = cloneDeep(Object.values(roleForEdit.posPayload));

      setBackOfficeOptions([...backOfficeData]);
      setPosOptions([...posData]);
      setRoleForEditing(cloneDeep({ ...roleForEdit, name: roleForEdit?.caseSensitiveName }));
    } else {
      // setBackOfficeOptions([...BACK_OFFICE_OPTIONS]);
      setBackOfficeOptions([...BACK_OFFICE_OPTIONS_NEW_ROLE]);
      setPosOptions([...POS_OPTIONS]);
      setShowBackOfficeOptions(false);
      setShowPosOptions(false);
    }
  }, [dispatch, roleForEdit, openRolesAddDialog, edit]);

  useEffect(() => {
    if (roleForEdit?.backOffice) {
      setShowBackOfficeOptions(true);
    }
    if (roleForEdit?.pos) {
      setShowPosOptions(true);
    }
  }, [roleForEdit]);

  // Filtering users with the role
  useEffect(() => {
    if (roleForEdit && users?.length) {
      let data = users.filter((item) => {
        return item.role === roleForEdit._id;
      });
      setUsersWithRole(data);
    }
  }, [roleForEdit, openRolesAddDialog, users]);

  // Selecting filtered users ids
  useEffect(() => {
    let usersIds = [];
    if (usersWithRole?.length) {
      usersWithRole.forEach((user) => {
        return usersIds.push(user._id);
      });
    }
    setUsersIdsWithRole(usersIds);
  }, [usersWithRole]);

  const resetDefaultHandler = () => {
    if (roleForEdit.originalName === "owner") {
      // restore default owner role
      setRoleForEditing({ ...roleForEditing, name: "Owner" });
      setShowPosOptions(true);
      setShowBackOfficeOptions(true);
      setPosOptions([...POS_OPTIONS_DEFAULT]);
      setBackOfficeOptions([...BACK_OFFICE_OPTIONS_DEFAULT]);
    } else if (roleForEdit.originalName === "manager") {
      // restore default manager role
      setRoleForEditing({ ...roleForEditing, name: "Manager" });
      setShowPosOptions(false);
      setShowBackOfficeOptions(true);
      setPosOptions([...POS_OPTIONS_MANAGER]);
      setBackOfficeOptions([...BACK_OFFICE_OPTIONS_MANAGER]);
    } else if (roleForEdit.originalName === "cashier") {
      // restore default cashier role
      setRoleForEditing({ ...roleForEditing, name: "Cashier" });
      setShowPosOptions(true);
      setShowBackOfficeOptions(false);
      setPosOptions([...POS_OPTIONS_CASHIER]);
      setBackOfficeOptions([...BACK_OFFICE_OPTIONS_CASHIER]);
    }
    setResetToDefault(true);
  };

  const handleClosePaymentDialog = (dirty, resetForm) => {
    if (dirty) {
      setShowUnsavedChangesModal(true);
    } else {
      setOpenRolesAddDialog(false);
      setPosOptions([...POS_OPTIONS]);
      setBackOfficeOptions([...BACK_OFFICE_OPTIONS]);
      setShowBackOfficeOptions(false);
      setShowPosOptions(false);
      resetForm();
      setResetToDefault(false);
    }
  };

  const handleDisableFields = () => {
    return roleForEdit?.originalName === "owner" ? true : false;
  };
  const { language } = useSelector((state) => state.auth);

  useEffect(() => {
    if (
      (roleForEdit?.originalName === "cashier" &&
        showPosOptions &&
        !showBackOfficeOptions &&
        isEqual(POS_OPTIONS_CASHIER, posOptions) &&
        isEqual(BACK_OFFICE_OPTIONS_CASHIER, backOfficeOptions)) ||
      (roleForEdit?.originalName === "manager" &&
        !showPosOptions &&
        showBackOfficeOptions &&
        isEqual(POS_OPTIONS_MANAGER, posOptions) &&
        isEqual(BACK_OFFICE_OPTIONS_MANAGER, backOfficeOptions))
    ) {
      setResetToDefault(true);
    } else {
      setResetToDefault(false);
    }
    //eslint-disable-next-line
  }, [posOptions, backOfficeOptions, showPosOptions, showBackOfficeOptions]);

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={edit ? roleForEditing : initAddState}
        validationSchema={AddRoleSchema}
        onSubmit={(values, { resetForm }) => {
          if (roleForEdit && edit) {
            dispatch(
              rolesActions.updateRole(roleForEdit._id, {
                name: values.name,
                pos: showPosOptions,
                backOffice: showBackOfficeOptions,
                backOfficePayload: [...backOfficeOptions],
                posPayload: [...posOptions],
                caseSensitiveName: values.name,
              }),
            );
            if (usersIdsWithRole?.length) {
              dispatch(
                usersActions.updateUsersWithRole(usersIdsWithRole, {
                  name: values.name,
                  originalName: roleForEdit?.originalName,
                  pos: showPosOptions,
                  backOffice: showBackOfficeOptions,
                  backOfficePayload: [...backOfficeOptions],
                  posPayload: [...posOptions],
                }),
              );
            }
          } else {
            dispatch(
              rolesActions.createRole({
                ...values,
                originalName: values.name,
                backOfficePayload: [...backOfficeOptions],
                posPayload: [...posOptions],
                caseSensitiveName: values.name,
              }),
            );
          }
          // Resetting Form Values
          resetForm();
          setPosOptions([...POS_OPTIONS]);
          setBackOfficeOptions([...BACK_OFFICE_OPTIONS]);
          setShowBackOfficeOptions(false);
          setShowPosOptions(false);
          setOpenRolesAddDialog(false);
        }}
      >
        {({ handleSubmit, values, setFieldValue, resetForm, dirty }) => {
          if (values.name) {
            setIsFormFilled(true);
          } else setIsFormFilled(false);
          return (
            <>
              <Modal
                className={`${language === "arabic" ? "modal-dialog-arabic modal-drawer" : " modal-drawer"}  my-profile invoice-drawer`}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"
                show={openRolesAddDialog}
                onHide={() => handleClosePaymentDialog(dirty, resetForm)}
              >
                <Modal.Header>
                  <div className={`d-flex justify-content-around align-items-center ${language === "arabic" ? "rtl" : "ltr"}`}>
                    <span onClick={() => handleClosePaymentDialog(dirty, resetForm)} className="cursor-pointer">
                      <img src={IconClose} alt="loading" />
                    </span>
                    <span>
                      {edit === false ? (
                        <span className="add-edit-tax">{i18n("Company.AddRole")}</span>
                      ) : (
                        <span className="add-edit-tax">{i18n("Company.EditRole")}</span>
                      )}
                    </span>
                    <span
                      onClick={handleSubmit}
                      className="add-edit-tax cursor-pointer"
                      style={{
                        color: isFormFilled && "#FFFFFF",
                        opacity: isFormFilled ? 1 : 0.5,
                      }}
                    >
                      {i18n("UserProfile.Save")}
                    </span>
                  </div>
                </Modal.Header>

                <Modal.Body className={`overlay overlay-block cursor-default ${language === "arabic" ? "rtl" : "ltr"}`}>
                  <Form className="form form-label-right">
                    <div className="form-group">
                      <Field
                        name="name"
                        component={Input}
                        disabled={nameDisabled}
                        label={i18n("Company.RoleName")}
                        placeholder={i18n("Company.RoleName")}
                        withFeedbackLabel={true}
                      />
                    </div>

                    <div className="d-flex justify-content-between">
                      <h6 className="mt-4">{i18n("Company.BackOffice")}</h6>
                      <div style={{ marginTop: "-7px" }}>
                        <SwitchToggler
                          className="default-switch"
                          id="backOffice"
                          name="backOffice"
                          value="backOffice"
                          disabled={handleDisableFields()}
                          checked={showBackOfficeOptions || false}
                          onChange={(e) => {
                            setShowBackOfficeOptions(e.target.checked);
                            setFieldValue("backOffice", e.target.checked);
                          }}
                        />
                      </div>
                    </div>
                    <p className="text-muted">{i18n("Company.UsersCanLoginWithEmailAndPassword")}</p>

                    {showBackOfficeOptions &&
                      backOfficeOptions.map((item, index) => (
                        <div key={index}>
                          <div>
                            <Field
                              name={item.name}
                              component={Checkbox}
                              checked={item.selected}
                              disabled={disabled || handleDisableFields()}
                              onChange={(e) => {
                                let newOption = {
                                  ...item,
                                  selected: e.target.checked,
                                };
                                backOfficeOptions[index] = newOption;
                                setBackOfficeOptions([...backOfficeOptions]);
                              }}
                            />
                            {language === "arabic" ? translateRoleName(item.name) : item.name}
                          </div>
                          {item.selected &&
                            item?.subItem?.length &&
                            item.subItem.map((it, ind) => (
                              <div
                                className="d-flex"
                                style={{ marginLeft: language === "english" && "2rem", marginRight: language === "arabic" && "2rem" }}
                                key={ind}
                              >
                                <Field
                                  name={it.name}
                                  component={Checkbox}
                                  checked={it.selected}
                                  disabled={it.name === "Products" || it.name === "Company Information" ? true : disabled || handleDisableFields()}
                                  onChange={(e) => {
                                    item.subItem[ind] = {
                                      ...item.subItem[ind],
                                      selected: e.target.checked,
                                    };
                                    setBackOfficeOptions([...backOfficeOptions]);
                                  }}
                                />
                                <div className="mt-3">{language === "arabic" ? translateRoleName(it.name) : it.name}</div>
                              </div>
                            ))}
                        </div>
                      ))}

                    <div className="d-flex justify-content-between">
                      <h6 className="mt-4">{i18n("global.Pos")}</h6>
                      <div style={{ marginTop: "-7px" }}>
                        <SwitchToggler
                          className="default-switch"
                          id="Pos"
                          name="pos"
                          value="Pos"
                          disabled={handleDisableFields()}
                          checked={showPosOptions || false}
                          onChange={(e) => {
                            setShowPosOptions(e.target.checked);
                            setFieldValue("pos", e.target.checked);
                          }}
                        />
                      </div>
                    </div>
                    <p className="text-muted">{i18n("Company.UserCanLoginToAppUsingPosPin")}</p>

                    {showPosOptions &&
                      posOptions.map((item, index) => (
                        <div key={index}>
                          <div>
                            <Field
                              name={item.name}
                              disabled={disabled ? disabled : item.name === "View Invoices" || handleDisableFields()}
                              component={Checkbox}
                              checked={item.selected}
                              onChange={(e) => {
                                posOptions[index] = {
                                  ...item,
                                  selected: e.target.checked,
                                };
                                setPosOptions([...posOptions]);
                              }}
                            />
                            {language === "arabic" ? translateRoleName(item.name) : item.name}
                          </div>
                          {item.selected &&
                            item?.subItem?.length &&
                            item.subItem.map((it, ind) => (
                              <div
                                className=""
                                style={{ marginLeft: language === "english" && "3.3rem", marginRight: language === "arabic" && "3.3rem" }}
                                key={ind}
                              >
                                <Radio
                                  id={it.name}
                                  name="invoice"
                                  label={language === "arabic" ? translateRoleName(it.name) : it.name}
                                  value={it.name}
                                  disabled={disabled || handleDisableFields()}
                                  isSelected={it.selected}
                                  onChange={(e) => {
                                    let originalData = [
                                      {
                                        name: "Only Last 5",
                                        selected: false,
                                      },
                                      {
                                        name: "All Invoices",
                                        selected: false,
                                      },
                                    ];
                                    item.subItem = originalData;
                                    item.subItem[ind] = {
                                      ...it,
                                      selected: true,
                                    };
                                    setPosOptions([...posOptions]);
                                  }}
                                />
                              </div>
                            ))}
                        </div>
                      ))}

                    {edit &&
                      (roleForEdit?.originalName === "owner" ||
                        roleForEdit?.originalName === "manager" ||
                        roleForEdit?.originalName === "cashier") && (
                        <div
                          className="row ml-3 mt-3"
                          style={{
                            color: resetToDefault ? "#2D9CDB80" : "#2D9CDB",
                            pointerEvents: resetToDefault ? "none" : "all",
                          }}
                          onClick={resetDefaultHandler}
                        >
                          {resetToDefault ? (
                            <img width={18} height={18} src={resetLight} alt="loading" />
                          ) : (
                            <img width={18} height={18} src={resetDark} alt="loading" />
                          )}
                          <div className={`cursor-pointer ${language === "arabic" ? "mr-3" : "ml-3"}`}>{i18n("Company.ResetAllToDefault")}</div>
                        </div>
                      )}

                    {/* Unsaved changes modal */}
                    <SubscriptionDialog
                      modalWidth={"350px"}
                      modalHeight={"185px"}
                      modalBackgroundColor={"#FFFFFF"}
                      show={showUnsavedChangesModal}
                      onHide={() => setShowUnsavedChangesModal(false)}
                      title={i18n("SubscriptionModals.UnsavedChanges")}
                      titleWidth={"140px"}
                      titleHeight={"20px"}
                      titleFontWeight={"700"}
                      titleFontSize={"16px"}
                      titleLineHeight={"20px"}
                      titleColor={"#333333"}
                      message={i18n("SubscriptionModals.AreYouSureYouWantToContinueWithoutSavingChanges")}
                      messageWidth={"320px"}
                      messageHeight={"44px"}
                      messageFontSize={"16px"}
                      messageFontWeight={"400"}
                      messageLineHeight={"21.79px"}
                      messageColor={"#333333"}
                      primaryLabel={i18n("SubscriptionModals.CANCEL")}
                      primaryAction={() => setShowUnsavedChangesModal(false)}
                      primaryLabelWidth={"55px"}
                      primaryLabelHeight={"20px"}
                      primaryLabelFontWeight={"700"}
                      primaryLabelFontSize={"14px"}
                      primaryLabelLineHeight={"20px"}
                      primaryLabelColor={"#828282"}
                      secondaryAction={() => {
                        setShowUnsavedChangesModal(false);
                        setOpenRolesAddDialog(false);
                        setIsFormFilled(false);
                        resetForm();
                      }}
                      secondaryLabel={i18n("SubscriptionModals.CONTINUE")}
                      secondaryLabelWidth={"75px"}
                      secondaryLabelHeight={"20px"}
                      secondaryLabelFontWeight={"700"}
                      secondaryLabelFontSize={"14px"}
                      secondaryLabelLineHeight={"20px"}
                      secondaryLabelColor={"#2D9CDB"}
                      isCenteredOnMobile
                    />
                  </Form>

                  <div className="mt-5">
                    {edit &&
                    handleDataPermissions(user)?.deleteData &&
                    roleForEdit?.originalName !== "owner" &&
                    roleForEdit?.originalName !== "cashier" &&
                    roleForEdit?.originalName !== "manager" ? (
                      <Card>
                        <div className="w-100">
                          <div className="text-center">
                            <img
                              src={DeleteIcon}
                              alt="delete"
                              width={18}
                              height={20}
                              className="cursor-pointer"
                              onClick={() => setShowDeleteRoleModal(true)}
                            />
                          </div>
                        </div>
                      </Card>
                    ) : null}
                  </div>
                </Modal.Body>

                {/* <Modal.Footer>
                  <div className="row justify-content-center">
                    {edit ? (
                      <button
                        type="submit"
                        onClick={() => {
                          setShowConfirmChanges(true);
                        }}
                        className="btn btn-primary btn-elevate f-button"
                        style={{ display: "block" }}
                      >
                        Save
                      </button>
                    ) : (
                      <button type="submit" onClick={handleSubmit} className="btn btn-primary btn-elevate f-button ml-5" style={{ display: "block" }}>
                        Save
                      </button>
                    )}
                  </div>
                </Modal.Footer> */}

                {/* Confirmation modals */}

                {/*                 
                <ConfirmationDialoge
                  show={showConfirmChanges}
                  title="Confirm Changes"
                  subTitle={`You have made some changes to the permissions related to "${roleForEdit?.name}" role, are you sure you want to permanently save these changes?`}
                  primaryAction={handleSubmit}
                  secondaryAction={() => setShowConfirmChanges(false)}
                  primaryActionTitle="Confirm"
                  secondaryActionTitle="Cancel"
                  classes="modal-drawer"
                  heading="Confirm Changes!"
                  viewButton={true}
                />
                <ConfirmationDialoge
                  show={showDefaultChanges}
                  title="Confirm Reset to Default!"
                  subTitle="Are you sure you want to reset to default?"
                  primaryAction={() => resetDefaultHandler()}
                  secondaryAction={() => setShowDefaultChanges(false)}
                  primaryActionTitle="Confirm"
                  secondaryActionTitle="Cancel"
                  classes="modal-drawer"
                  heading="Confirm Reset to default!"
                  viewButton={true}
                /> */}
              </Modal>
            </>
          );
        }}
      </Formik>
    </>
  );
}
